import {
  ACCOUNT_ID,
  APP_HOST,
  ROOT_URL,
  usePublicPortfolioByAccount,
} from '@utils/apiHooks';
import {
  SocialFooterRoot,
  SocialWrapper,
  MainContainer,
  RightColumn,
  SocialIcon,
  LinksContainer,
} from './styles';
import Link, { HOME_PAGE } from '@components/Link';
import {
  formatWebsiteLink,
  getFullFacebookHttpLink,
  getFullInstagramHttpLink,
  getFullLinkedInHttpLink,
  getFullTwitterHttpLink,
  getFullXingHttpLink,
} from '@utils/fn';

import Logo from '@components/Logo';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import footerLogo from '@assets/images/footer_logo.png';
import { useMobileWidth } from '@utils/hooks';

function FooterSocial() {
  const { t } = useTranslation();
  const isMobile = useMobileWidth();
  const { data: portfolios } = usePublicPortfolioByAccount({
    accountId: ACCOUNT_ID,
  });

  const contact = useMemo(
    () => portfolios?.data?.[0]?.account?.contact,
    [portfolios?.data]
  );
  // added comment
  const socialMediaIcons = useMemo(
    () => [
      {
        name: 'social_facebook',
        url: getFullFacebookHttpLink(contact?.facebook),
      },
      {
        name: 'social_twitter',
        url: getFullTwitterHttpLink(contact?.twitter),
      },
      {
        name: 'social_instagram',
        url: getFullInstagramHttpLink(contact?.instagram),
      },
      {
        name: 'social_linkedin',
        url: getFullLinkedInHttpLink(contact?.linkedin),
      },
      { name: 'social_xing', url: getFullXingHttpLink(contact?.xing) },
      {
        name: 'social_youtube',
        url: formatWebsiteLink(contact?.youtube),
      },
    ],
    [
      contact?.facebook,
      contact?.instagram,
      contact?.linkedin,
      contact?.twitter,
      contact?.xing,
      contact?.youtube,
    ]
  );
  return (
    <SocialFooterRoot>
      <MainContainer>
        <a
          href={APP_HOST}
          aria-label={`${portfolios?.data?.[0]?.account?.name ?? 'we.CONECT'} homepage`}
          style={{ display: 'inline-block' }}
        >
          <Logo
            src={footerLogo}
            width={isMobile ? '21.8rem' : '23.4rem'}
            height={isMobile ? '4rem' : '4.3rem'}
            $clickable
            alt={`${portfolios?.data?.[0]?.account?.name as string} Logo`}
          />
        </a>
        <RightColumn>
          <SocialWrapper>
            {socialMediaIcons?.map(({ name, url }) => (
              <SocialIcon
                key={name}
                className={`icon-${name}`}
                onClick={() => {
                  window.open(url, '_blank');
                }}
              />
            ))}
          </SocialWrapper>
          <LinksContainer>
            <Link
              to={t('footer.imprint-url')}
              $color="white"
              fontSize="1.8rem"
              $noPadding
            >
              {t('imprint')}
            </Link>
            <Link
              to={t('footer.terms-url')}
              $color="white"
              fontSize="1.8rem"
              $noPadding
            >
              {t('terms-&-conditions')}
            </Link>
            <Link
              to={t('footer.privacy-url')}
              $color="white"
              fontSize="1.8rem"
              $noPadding
            >
              {t('privacy-policy')}
            </Link>
          </LinksContainer>
        </RightColumn>
      </MainContainer>
    </SocialFooterRoot>
  );
}

export default FooterSocial;
